<template>
    <card-list>
        <subheader-list-item icon="fa-align-left" title="Fee Information"/>

        <container-list-item padded no-border>
            <div class="columns">
                <div class="column">
                    <b-field label="Title" label-position="inside">
                        <b-input v-model="fee.title"></b-input>
                    </b-field>
                </div>
                <div class="column is-4">
                    <b-field label="Price" label-position="inside">
                        <b-input v-model="fee.fee" placeholder="0.00"></b-input>
                    </b-field>
                </div>
            </div>
        </container-list-item>
    </card-list>
</template>

<script>
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SeparatorListItem from "@/components/common/SeparatorListItem";

    export default {
        name: 'RmcFeeForm',
        props: {
            fee: {
                type: Object,
                required: true
            },
        },
        components: {SeparatorListItem, CardListItem, ContainerListItem, SubheaderListItem, CardList},
        data: function() {
            return {
                type: null,
                title: null,
                componentSelect: null,
                components: [],
                editorOptions: {}
            };
        },
        computed: {},
        methods: {

        },
        mounted: function() {

        }
    };
</script>
